<template>
  <div class="new-domain-index">
    <DomainHeader></DomainHeader>
    <DomainDomainSearch @query="queryDomain"></DomainDomainSearch>
    <DomainContent></DomainContent>

  </div>
</template>
<script>
import DomainHeader from './components/header'
import DomainDomainSearch from './components/new-domain-search'
import DomainContent from './components/new-domain-content'
export default {
  data () {
    return {
      domainSuffixs: []
    }
  },
  components: {
    DomainHeader,
    DomainDomainSearch,
    DomainContent
  },
  methods: {
    queryDomain (domain) {
      const { domainName, domainSuffix } = domain
      const cnReg = /[\u4e00-\u9fa5]/g

      //
      // if (cnReg.test(domainName) && this.tableActive !== 1) {
      //   this.tableActive = 1
      // }

      // if (domainSuffix) {
      //   this.cards[this.tableActive].checked = [domainSuffix]
      // }

      if (domainSuffix.length === 0) {
        this.$msgbox({
          type: 'error',
          message: '请至少选择一个域名后缀'
        })
        return
      }
      this.$router.push({
        path: '/domain/result',
        query: {
          domainName: domainName.toLowerCase(),
          domainSuffixs: domainSuffix
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/new-domain-index.vue